// ----------- AUTH
export const UPDATE_CHANNEL_KEY = 'UPDATE_CHANNEL_KEY';
export const UPDATE_API_KEY = 'UPDATE_API_KEY';
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
export const CLEAR_USER_INFO = 'CLEAR_USER_INFO';

// ----------- CALENDAR
export const UPDATE_LIST_PARAMS = 'UPDATE_LIST_PARAMS';
export const UPDATE_CALENDAR_PARAMS = 'UPDATE_CALENDAR_PARAMS';
export const RESET_EVENT_PARAMS = 'RESET_EVENT_PARAMS';

// ----------- CHANNEL
export const UPDATE_CHANNEL_SETTINGS = 'UPDATE_CHANNEL_SETTINGS';
export const UPDATE_CHANNEL_MENU = 'UPDATE_CHANNEL_MENU';
export const UPDATE_CHANNEL_SLIDES = 'UPDATE_CHANNEL_SLIDES';
export const UPDATE_CHANNEL_PAGES = 'UPDATE_CHANNEL_PAGES';

// ----------- CUSTOM FORM
export const UPDATE_CUSTOM_FORM_DATA = 'UPDATE_CUSTOM_FORM_DATA';

// ----------- EVENT
export const UPDATE_EVENTS_LIST = 'UPDATE_EVENTS_LIST';
export const CLEAR_EVENTS_LIST = 'CLEAR_EVENTS_LIST';
export const SET_EVENT_REQUEST_OFFSET = 'SET_EVENT_REQUEST_OFFSET';
export const RESET_EVENT_REQUEST_OFFSET = 'RESET_EVENT_REQUEST_OFFSET';
export const SET_EVENT_META = 'SET_EVENT_META';
export const CLEAR_EVENT_META = 'CLEAR_EVENT_META';
export const UPDATE_EVENTS_CATEGORIES = 'UPDATE_EVENTS_CATEGORIES';

// ----------- FAQ
export const UPDATE_FAQ = 'UPDATE_FAQ';

// ----------- GEO
export const UPDATE_GEO_DATA = 'UPDATE_GEO_DATA';

// ----------- PARTICIPANTS
export const UPDATE_PARTICIPANTS_LIST = 'UPDATE_PARTICIPANTS_LIST';

// ----------- PAYMENT
export const UPDATE_PACKAGES_LIST = 'UPDATE_PACKAGES_LIST';
export const UPDATE_SUBSCRIPTIONS_LIST = 'UPDATE_SUBSCRIPTIONS_LIST';
export const UPDATE_ORDERS_LIST = 'UPDATE_ORDERS_LIST';

// ----------- SETTINGS
export const ADD_TOAST = 'ADD_TOAST';
export const REMOVE_TOAST = 'REMOVE_TOAST';

// ------------ GLOBAL
export const CLEAR_CACHE = 'CLEAR_CACHE';
export const RESET_STATE = 'RESET_STATE';
